<template>
  <div>
    <v-menu bottom left :disabled="disabled">
      <v-btn small flat slot="activator" class="mr-0 pr-0">
        <template v-if="linkingField">
          <v-icon v-if="!disabled" class="mr-1" small>arrow_drop_down</v-icon>
          Vinculado a {{ translateField(linkingField) }}
        </template>
        <template v-else>
          <v-icon class="mr-1" small>add</v-icon>
          Vincular a campo
        </template>
      </v-btn>
      <v-list dense>
        <v-list-tile
          ripple
          v-for="field in linkableFields"
          :key="field"
          @click="linkField(field)"
        >
          <v-list-tile-action>
            <v-icon small color="primary" v-text="field === linkingField ? 'remove' : 'add'"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-if="field === linkingField">
              Desvincular de {{ translateField(field) }}
            </v-list-tile-title>
            <v-list-tile-title v-else>Vincular a {{ translateField(field) }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-menu>
    <template v-if="linkingField">
      <v-tooltip v-if="isLinked" bottom :disabled="disabled">
        <v-btn color="success" icon flat slot="activator" :disabled="disabled" >
          <v-icon>fa-link</v-icon>
        </v-btn>
        <span>Campo sincronizado</span>
      </v-tooltip>
      <v-tooltip v-else bottom :disabled="disabled">
        <v-btn color="warning" icon flat slot="activator" :disabled="disabled" @click="syncField(linkingField)">
          <v-icon>fa-unlink</v-icon>
        </v-btn>
        <span>Volver a sincronizar campo</span>
      </v-tooltip>
    </template>

  </div>
</template>

<script>
export default {
  props: {
    field: {
      type: String,
      required: true,
    },
    linkingField: {
      type: String,
    },
    linkableFields: {
      type: Array,
      required: true,
    },
    isLinked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    syncField(linkingField) {
      this.$emit('linkField', {
        field: this.field,
        linkingField,
      });
    },
    linkField(linkingField) {
      this.$emit('linkField', {
        field: this.field,
        linkingField: linkingField !== this.linkingField ? linkingField : null,
      });
    },
    translateField(field) {
      const translation = `message.form.fields.${field}`;
      return this.$te(translation) ? this.$t(translation) : field;
    },
  },
};
</script>

<style lang="stylus" scoped>
.linking-field {
  &:hover {
    cursor: pointer
    text-decoration: underline;
  }
}
</style>
